import { Redirect, Stack } from 'expo-router'
import { Text } from 'react-native'
import { useSelector } from 'react-redux'
import { SWRConfig, SWRConfiguration, Fetcher } from 'swr'
import { getString, remoteConfig } from '~providers/firebase'
import { ApplicationState } from '~redux'
import fetch from '~utils/fetch'

export const unstable_settings = {
  initialRouteName: '(tabs)',
}

const swrConfig: Partial<SWRConfiguration<any, any, Fetcher<any>>> = {
  fetcher: fetch,
  shouldRetryOnError: false,
}

export default function AppLayout() {
  const { isAuthenticated, loading, termsAndConditions } = useSelector(
    (state: ApplicationState) => state.auth,
  )

  // You can keep the splash screen open, or render a loading screen like we do here.
  if (loading === 'pending' || loading === 'idle') {
    return <Text>Loading...</Text>
  }

  // Only require authentication within the (app) group's layout as users
  // need to be able to access the (auth) group and sign in again.
  if (!isAuthenticated) {
    // On web, static rendering will stop here as the user is not authenticated
    // in the headless Node process that the pages are rendered in.
    return <Redirect href="/login" />
  }

  if (termsAndConditions !== getString(remoteConfig, 'terms_and_conditions_version')) {
    return <Redirect href="/terms-and-conditions" />
  }

  // This layout can be deferred because it's not the root layout.
  return (
    <SWRConfig value={swrConfig}>
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen name="(tabs)" />
        <Stack.Screen
          name="denied"
          options={{
            presentation: 'modal',
            webModalStyle: {
              height: '90%',
              width: '95%',
            },
          }}
        />
      </Stack>
    </SWRConfig>
  )
}
